import React, { lazy } from 'react';
import { MapPin, Phone, Mail, Clock, ExternalLink } from 'lucide-react';
export function LocationSection() {
  return <section id="location" className="py-20 md:py-24 bg-surface/30" data-id="element-203">
      <div className="container mx-auto px-4" data-id="element-204">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 rounded-xl overflow-hidden bg-card border border-border shadow-xl" data-id="element-205">
          {/* Map Column */}
          <div className="h-[400px] lg:h-auto w-full relative" data-id="element-206">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2381.846436666847!2d-6.265464923287344!3d53.34603997228965!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e8353664735%3A0x6e301297120790e!2sThe%20Old%20Mill%20Restaurant!5e0!3m2!1sen!2sie!4v1709221234567!5m2!1sen!2sie" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" className="absolute inset-0 grayscale hover:grayscale-0 transition-all duration-500" title="The Old Mill Restaurant Location" data-id="element-207"></iframe>
          </div>

          {/* Info Column */}
          <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-208">
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-foreground mb-8" data-id="element-209">
              Visit Us
            </h2>

            <div className="space-y-6 mb-10" data-id="element-210">
              <div className="flex items-start gap-4" data-id="element-211">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0" data-id="element-212">
                  <MapPin className="w-5 h-5 text-primary" data-id="element-213" />
                </div>
                <div data-id="element-214">
                  <h3 className="font-bold text-foreground mb-1" data-id="element-215">Address</h3>
                  <p className="text-muted-foreground" data-id="element-216">
                    14 Temple Bar Square,
                    <br data-id="element-217" />
                    Dublin 2, Ireland
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-218">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0" data-id="element-219">
                  <Phone className="w-5 h-5 text-primary" data-id="element-220" />
                </div>
                <div data-id="element-221">
                  <h3 className="font-bold text-foreground mb-1" data-id="element-222">Phone</h3>
                  <a href="tel:+35316719266" className="text-muted-foreground hover:text-primary transition-colors" data-id="element-223">
                    +353 1 671 9266
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-224">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0" data-id="element-225">
                  <Mail className="w-5 h-5 text-primary" data-id="element-226" />
                </div>
                <div data-id="element-227">
                  <h3 className="font-bold text-foreground mb-1" data-id="element-228">Email</h3>
                  <a href="mailto:info@oldmillrestaurant.ie" className="text-muted-foreground hover:text-primary transition-colors" data-id="element-229">
                    info@oldmillrestaurant.ie
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-230">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0" data-id="element-231">
                  <Clock className="w-5 h-5 text-primary" data-id="element-232" />
                </div>
                <div data-id="element-233">
                  <h3 className="font-bold text-foreground mb-1" data-id="element-234">
                    Opening Hours
                  </h3>
                  <p className="text-muted-foreground" data-id="element-235">Daily 09:00 – 22:30</p>
                  <p className="text-xs text-muted-foreground/60 mt-1 italic" data-id="element-236">
                    Hours may vary on holidays
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-237">
              <a href="tel:+35316719266" className="inline-flex items-center justify-center px-6 py-3 bg-primary text-primary-foreground font-bold rounded-md hover:bg-primary/90 transition-colors" data-id="element-238">
                <Phone className="w-4 h-4 mr-2" data-id="element-239" />
                Call Now
              </a>
              <a href="https://www.google.com/maps/dir/?api=1&destination=14+Temple+Bar+Square+Dublin+2+Ireland" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 border border-border text-foreground font-bold rounded-md hover:border-primary hover:text-primary transition-colors" data-id="element-240">
                <ExternalLink className="w-4 h-4 mr-2" data-id="element-241" />
                Get Directions
              </a>
              <a href="mailto:info@oldmillrestaurant.ie" className="inline-flex items-center justify-center px-6 py-3 border border-border text-foreground font-bold rounded-md hover:border-primary hover:text-primary transition-colors" data-id="element-242">
                <Mail className="w-4 h-4 mr-2" data-id="element-243" />
                Email Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}